<template>
  <div class="webdatalist">
    <f7-list media-list class="searchbar-found" id="contacts-list">
      <div v-if="Object.keys(contacts).length > 0">
        <ul v-for="(group, key) in contacts" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
          <li v-for="contact in group" :key="contact.id" class="testTap cursor contact-line">
            <div class="item-content" @click="contactDetail(contact)">
              <div class="item-inner contact-list-table my-auto">
                {{ contact.label }}
              </div>
              <div class="item-title contactItem contact-list-table my-auto">{{ contact.name }}</div>
              <div class="item-media contact-list-table mr-50px">
                <b-button variant="tertiary" class="mx-2 btn-contact-list"
                  :title="removelabel"
                  @click="removeContact(contact, $event)" delete>
                  <i class="fa-light fa-trash"></i>
                </b-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="noResult">
        {{ $t('common.no_result') }}
      </div>

    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ContactList',
  props: ['contacts'],
  data () {
    return {
      editlabel: '',
      removelabel: '',
      canRemoveContact: false,
      canEditContact: false
    }
  },
  created () {
    this.canRemoveContact = this.$engine.rights.rightIs('contact_supprimer', true)
    this.canEditContact = this.$engine.rights.rightIs('contact_editer', true)

    this.editlabel = this.$i18n.t('common.edit_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.removelabel = this.$i18n.t('common.rm_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
  },
  methods: {
    editContact (contact, e) {
      e.stopPropagation()
      if (!this.canEditContact) {
        return
      }
      this.$engine.settings.set({currentContact: contact})
      var formData = {
        'username': contact.name,
        'identifier': contact.identifier,
        'iban': contact.iban,
        'label': contact.label,
        'phoneNumber': contact.phoneNumber,
        'address': contact.address,
        'city': contact.city,
        'zipCode': contact.zipCode,
        'typeContact': contact.typeContact,
        'idCompany': contact.idCompany,
        'idProvider': contact.idProvider
      }
      this.$f7.formFromData('#EditContactForm', formData)
      loadPage(this, {url: '/account/editContact/'})
    },
    contactDetail (contact) {
      this.$engine.settings.set({currentContact: contact})
      var formData = {
        'username': contact.name,
        'identifier': contact.identifier,
        'iban': contact.iban,
        'label': contact.label,
        'phoneNumber': contact.phoneNumber,
        'address': contact.address,
        'city': contact.city,
        'zipCode': contact.zipCode,
        'typeContact': contact.typeContact,
        'idCompany': contact.idCompany,
        'idProvider': contact.idProvider
      }
      this.$f7.formFromData('#EditContactForm', formData)
      loadPage(this, {url: '/account/contactDetail/'})
    },
    removeContact (contact, e) {
      e.stopPropagation()
      if (!this.canRemoveContact) {
        return
      }
      let that = this
      that.$engine.contacts
        .delete(contact.id)
        .then(resp => {
          that.$f7.modal({
            title: that.$i18n.t('contacts.cntct_dltd'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.identifier = ''
            that.username = ''
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
          }, 1000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
    }
  }
}
</script>



